class AlgoliaComponent {
  constructor() {
    this.algoliaInitHooks();
  }


  algoliaInitHooks() {
    const algoliaShopify = window.algoliaShopify;
    if (!algoliaShopify) {
      console.warn('window.algoliaShopify not found!');
      const collectionFallback = document.querySelector(
        '.collection.is-fallback'
      );
      collectionFallback?.classList.add('show-fallback');
      return;
    }

    // On algolia hooks init
    document.addEventListener('algolia.hooks.initialize', function () {
      // Instantsearch - add custom sort order (virtual replica)
      algoliaShopify.hooks.registerHook(
        "beforeInstantSearchInitCollectionSortOrders",
        /** @param {any} sortOrders */
        (sortOrders) => {
          return [
            sortOrders,
            { value: 'virtual_search_sort_best_selling', label: 'Bestselling' },
            { value: 'shopify_products_inventory_quantity_desc', label: 'Most available' },
            { value: 'shopify_products_title_ascending2', label: 'Name A-Z' },
            { value: 'shopify_products_title_descending2', label: 'Name Z-A' },
            { value: 'shopify_products_price_asc', label: 'Price Low to High' },
            { value: 'shopify_products_price_desc', label: 'Price High to Low' },
            { value: 'shopify_new_arrivals', label: 'New Arrivals' },
          ];
        },
      );

      algoliaShopify.hooks.registerHook(
        "beforeInstantSearchInitSearchSortOrders",
        /** @param {any} sortOrders */
        (sortOrders) => {
          return [
            sortOrders,
            { value: 'virtual_search_sort_best_selling', label: 'Bestselling' },
            { value: 'shopify_products_inventory_quantity_desc', label: 'Most available' },
            { value: 'shopify_products_title_ascending2', label: 'Name A-Z' },
            { value: 'shopify_products_title_descending2', label: 'Name Z-A' },
            { value: 'shopify_products_price_asc', label: 'Price Low to High' },
            { value: 'shopify_products_price_desc', label: 'Price High to Low' },
            { value: 'shopify_new_arrivals', label: 'New Arrivals' },
          ];
        },
      );

      // Instantsearch - render custom main template
      algoliaShopify.hooks.registerHook(
        'beforeInstantSearchMainTemplate',
        /**
         * @param {any} _defaultTemplate
         * @param {any} data
         * @param {any} html
         */
        function (_defaultTemplate, data, html) {
          const collectionDescription = document.createElement('div');
          collectionDescription.innerHTML = window.collectionDescription;
          const collectionDescriptionTruncated =
            collectionDescription.innerText.slice(0, 18).trim() + '...';

          return html`
            <div class="collection" data-collection>
              <div class="collection__inner">

                <div class="collection__header">
                  ${window.collectionTitle &&
                  html`
                    <h1 class="collection__title h2">
                      ${window.collectionTitle}
                    </h1>
                  `}

                  <div class="ais-input">
                    <div class="ais-search-box-container"></div>
                    <div class="ais-input-button">
                      <div class="ais-clear-input-icon"></div>
                    </div>
                  </div>

                  <div class="collection__filters">
                    ${data.multipleSortOrders
                      ? html`
                          <span
                            class="ais-sort-orders-container collection__sort"
                          ></span>
                        `
                      : html` ${algoliaShopify.translations.relevance} `}

                    <button
                      class="collection__filters-show button-unstyled"
                      data-filters-show
                    >
                      <div class="ais-facets-button"></div>
                      <svg
                        viewBox="0 0 25 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.78711 8.24999H6.88086C7.04609 8.8953 7.42138 9.46727 7.94759 9.87572C8.4738 10.2842 9.12098 10.5059 9.78711 10.5059C10.4532 10.5059 11.1004 10.2842 11.6266 9.87572C12.1528 9.46727 12.5281 8.8953 12.6934 8.24999H20.2871C20.486 8.24999 20.6768 8.17097 20.8174 8.03032C20.9581 7.88967 21.0371 7.6989 21.0371 7.49999C21.0371 7.30108 20.9581 7.11032 20.8174 6.96966C20.6768 6.82901 20.486 6.74999 20.2871 6.74999H12.6934C12.5281 6.10468 12.1528 5.53271 11.6266 5.12426C11.1004 4.71581 10.4532 4.49411 9.78711 4.49411C9.12098 4.49411 8.4738 4.71581 7.94759 5.12426C7.42138 5.53271 7.04609 6.10468 6.88086 6.74999H3.78711C3.5882 6.74999 3.39743 6.82901 3.25678 6.96966C3.11613 7.11032 3.03711 7.30108 3.03711 7.49999C3.03711 7.6989 3.11613 7.88967 3.25678 8.03032C3.39743 8.17097 3.5882 8.24999 3.78711 8.24999ZM9.78711 5.99999C10.0838 5.99999 10.3738 6.08797 10.6205 6.25279C10.8671 6.41761 11.0594 6.65188 11.1729 6.92597C11.2865 7.20006 11.3162 7.50166 11.2583 7.79263C11.2004 8.0836 11.0575 8.35087 10.8478 8.56065C10.638 8.77043 10.3707 8.91329 10.0797 8.97117C9.78877 9.02905 9.48717 8.99934 9.21308 8.88581C8.939 8.77228 8.70473 8.58002 8.53991 8.33335C8.37508 8.08667 8.28711 7.79666 8.28711 7.49999C8.28711 7.10217 8.44515 6.72064 8.72645 6.43933C9.00775 6.15803 9.38928 5.99999 9.78711 5.99999ZM20.2871 15.75H18.6934C18.5281 15.1047 18.1528 14.5327 17.6266 14.1243C17.1004 13.7158 16.4532 13.4941 15.7871 13.4941C15.121 13.4941 14.4738 13.7158 13.9476 14.1243C13.4214 14.5327 13.0461 15.1047 12.8809 15.75H3.78711C3.5882 15.75 3.39743 15.829 3.25678 15.9697C3.11613 16.1103 3.03711 16.3011 3.03711 16.5C3.03711 16.6989 3.11613 16.8897 3.25678 17.0303C3.39743 17.171 3.5882 17.25 3.78711 17.25H12.8809C13.0461 17.8953 13.4214 18.4673 13.9476 18.8757C14.4738 19.2842 15.121 19.5059 15.7871 19.5059C16.4532 19.5059 17.1004 19.2842 17.6266 18.8757C18.1528 18.4673 18.5281 17.8953 18.6934 17.25H20.2871C20.486 17.25 20.6768 17.171 20.8174 17.0303C20.9581 16.8897 21.0371 16.6989 21.0371 16.5C21.0371 16.3011 20.9581 16.1103 20.8174 15.9697C20.6768 15.829 20.486 15.75 20.2871 15.75ZM15.7871 18C15.4904 18 15.2004 17.912 14.9538 17.7472C14.7071 17.5824 14.5148 17.3481 14.4013 17.074C14.2878 16.7999 14.2581 16.4983 14.3159 16.2074C14.3738 15.9164 14.5167 15.6491 14.7264 15.4393C14.9362 15.2296 15.2035 15.0867 15.4945 15.0288C15.7854 14.9709 16.087 15.0006 16.3611 15.1142C16.6352 15.2277 16.8695 15.42 17.0343 15.6666C17.1991 15.9133 17.2871 16.2033 17.2871 16.5C17.2871 16.8978 17.1291 17.2793 16.8478 17.5607C16.5665 17.842 16.1849 18 15.7871 18Z"
                          fill="#282828"
                        />
                      </svg>
                      ${Theme.translations.filter_title}
                    </button>

                    <div class="collection__filters-overlay ais-facets">
                      <div class="collection__filters-header">
                        <button
                          class="collection__filters-close button-unstyled"
                          data-filters-close
                        >
                          <svg
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 0.999998L9 9M9 9L1 17M9 9L1 0.999998M9 9L17 17"
                              stroke="#282828"
                              stroke-width="1.6"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>

                        <span class="collection__filters-title h4">
                          ${Theme.translations.filter_title}
                        </span>

                        <div class="ais-clear-refinements-container"></div>
                        <div class="ais-current-refined-values-container"></div>
                      </div>

                      <div class="collection__filters-main">
                        <div class="collection__filters-main-inner">
                          ${algoliaShopify.config
                            .app_blocks_dynamic_widgets_beta_enabled
                            ? html`
                                <div
                                  class="ais-dynamic-widgets-container"
                                ></div>
                              `
                            : data.facets.map(
                                /** @param {any} facet */ (facet) =>
                                  html`
                                    <div
                                      class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                                    >
                                      <label
                                        for="${facet.escapedName}"
                                        class="ais-range-slider--header ais-facet--header ais-header"
                                        >${facet.title}</label
                                      >
                                      <input
                                        class="ais-dropdown-checkbox"
                                        type="checkbox"
                                        id="${facet.escapedName}"
                                        name="dropdown"
                                      />
                                      <span
                                        class="collection__filters-selected is-mobile p is-small"
                                        data-filters-selected
                                        data-facet-name="${facet.escapedName}"
                                      ></span>
                                      <div class="collection__filters-dropdown">
                                        <div class="collection__filters-header">
                                          <button
                                            class="collection__filters-back button-unstyled"
                                            data-filters-back
                                          >
                                            <svg
                                              viewBox="0 0 10 18"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M8.96484 1L1.00097 9L8.96484 17"
                                                stroke="#282828"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                              />
                                            </svg>
                                          </button>

                                          <span
                                            class="collection__filters-title h4"
                                          >
                                            ${facet.title}
                                          </span>

                                          <button
                                            class="collection__filters-clear button-unstyled"
                                            data-filters-clear
                                          >
                                            Clear
                                          </button>
                                        </div>
                                        <div
                                          class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                                        ></div>
                                      </div>
                                    </div>
                                  `
                              )}
                        </div>
                      </div>

                      <div class="collection__filters-footer">
                        <button
                          class="collection__filters-view button is-inverted"
                          data-filters-close
                        >
                          ${Theme.translations.filter_view}
                        </button>
                      </div>
                    </div>

                    <div
                      class="collection__filters-selected-all"
                      data-filters-selected-all
                    ></div>
                  </div>

                  <div class="collection__details">
                    <div class="ais-search-header">
                      <div class="ais-stats-container"></div>
                      <div class="ais-change-display">
                        <span
                          class="ais-change-display-block ais-change-display-selected"
                          ><i class="fa fa-th-large"></i
                        ></span>
                        <span class="ais-change-display-list"
                          ><i class="fa fa-th-list"></i
                        ></span>
                      </div>
                    </div>

                    ${algoliaShopify.is_collection_results_page
                      ? html`
                          <div class="collection__description">
                            ${collectionDescriptionTruncated}

                            <button
                              class="collection__description-more button-unstyled"
                              data-description-read-more
                            >
                              ${Theme.translations.description_read_more}
                            </button>
                          </div>
                        `
                      : ''}
                  </div>

                  <p class="collection__description-full">
                    ${collectionDescription.innerText}
                  </p>
                </div>

                <div class="collection__products">
                  <div
                    class="collection__products-inner ais-hits-container ais-results-as-block"
                  ></div>
                  <div class="ais-pagination-container"></div>
                </div>
              </div>
            </div>
          `;
        }
      );

      // Instantsearch - render custom stats template
      algoliaShopify.hooks.registerHook(
        'beforeInstantSearchStatsTemplate',
        /**
         * @param {any} _defaultTemplate
         * @param {any} data
         * @param {any} html
         */
        function (_defaultTemplate, data, html) {
          return html`
            ${data.hasOneResult &&
            html`
              <span class="ais-stats--nb-results">
                ${Theme.translations.results_count_single}
              </span>
            `}
            ${data.hasManyResults &&
            html`
              <span class="ais-stats--nb-results">
                ${Theme.translations.results_count?.replace(
                  '{{ count }}',
                  algoliaShopify.helpers.formatNumber(data.nbHits)
                )}
              </span>
            `}
          `;
        }
      );

      // Instantsearch - render custom product card template
      algoliaShopify.hooks.registerHook(
        'beforeInstantSearchProductTemplate',
        /**
         * @param {any} _defaultTemplate
         * @param {any} hit
         * @param {any} html
         * @param {any} components
         * @param {any} trackSearchAttribution
         */
        function (
          _defaultTemplate,
          hit,
          html,
          components,
          trackSearchAttribution
        ) {
          const hitImage = algoliaShopify.helpers.renderImage(hit, 250);
          const PLACEHOLDER_URL = 'https://koorong.com/cdn/shop/files/Shopify_Placeholder_Image.png';
          const finalImageSrc = hitImage.src && !hitImage.src.includes('no-image-compact.gif')
            ? hitImage.src
            : PLACEHOLDER_URL;
          const sizes = ['XX-Small','X-Small','Small','Medium','Large','X-Large','XX-Large','XXS','XS','S','M','L','XL','XXL','2XL','3XL','-'];
          const cleanTitle = hit.title
            .split(', ')
            .filter(part => !sizes.includes(part.trim()))
            .join(', ')
            .replace(/\s*-\s*Size\s+\S+/gi, '')
            .trim();



          const namedTagDiscount = hit.named_tags && hit.named_tags.currentCatDiscount
        ? Array.isArray(hit.named_tags.currentCatDiscount)
          ? Math.max(...hit.named_tags.currentCatDiscount.map(v => parseInt(v)))
          : parseInt(hit.named_tags.currentCatDiscount)
        : 0;



          const hasDiscount = namedTagDiscount > 0; // tag-driven, unchanged
          let discountPercentage = namedTagDiscount;

          // hit.price and hit.compare_at_price are in DOLLARS (e.g. 7.99)
          const compareAtPrice = parseFloat(hit.compare_at_price) || 0;
          const hasCompareAt = compareAtPrice > hit.price;

          let displayOriginalPrice = hit.price;
          let displaySalePrice = hit.price;

          if (hasDiscount) {
            // Tag discount: strike through list price, show calculated sale price
            displaySalePrice = Math.ceil(hit.price * (1 - namedTagDiscount / 100) * 100) / 100;
          } else if (hasCompareAt) {
            // Shopify compare-at: strike through compare-at, show list price
            displayOriginalPrice = compareAtPrice;
            discountPercentage = Math.round((1 - hit.price / compareAtPrice) * 100);
          }

          const showStrikethrough = hasDiscount || hasCompareAt;



          // Backorder / preorder
          const pubTimestamp = hit.meta?.custom?.publication_date
            ? new Date(hit.meta.custom.publication_date).getTime()
            : 0;
          const todayTimestamp = Date.now();

          const isBackorder =
            hit.inventory_available &&
            hit.inventory_quantity <= 0 &&
            hit.inventory_policy === 'continue' &&
            pubTimestamp > 0 &&
            pubTimestamp <= todayTimestamp &&
            hit.meta?.custom?.order_lead_time !== '';

          const isPreorder =
            hit.inventory_available &&
            hit.inventory_quantity <= 0 &&
            hit.inventory_policy === 'continue' &&
            pubTimestamp > 0 &&
            pubTimestamp > todayTimestamp;
          
          const isApparelGroup = !!(hit.named_tags && hit.named_tags['apparel-group']);

          // Inject no-icon style once
          if (!document.getElementById('algolia-apparel-style')) {
            const style = document.createElement('style');
            style.id = 'algolia-apparel-style';
            style.textContent = `.button.for-card.no-icon::after { display: none !important; }`;
            document.head.appendChild(style);
          }

          return html`
            <div
              class="product-card"
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              data-handle="${hit.handle}"
              data-variant-id="${hit.objectID}"
              data-distinct="${hit._distinct}"
              data-product-id="${hit.id}"
              onClick="${() => trackSearchAttribution(hit)}"
            >
              <div class="product-card__inner">
                <!-- Product Image -->
                <a
                  class="image product-card__image"
                  href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                  style="position: relative; display: block;"
                >
                  <img
                    src="${hitImage.src.includes('no-image-compact.gif') ? 'https://koorong.com/cdn/shop/files/Shopify_Placeholder_Image.png' : hitImage.src}"
                    srcset="${hitImage.srcset}"
                    sizes="${hitImage.sizes}"
                    alt="${hit.title}"
                    width="100%"
                    height="100%"
                  />

                  ${discountPercentage > 0
                    ? html`
                        <div class="product-card__discount-badge" data-discount-percent="${discountPercentage}">
                          ${discountPercentage}% OFF
                        </div>
                      `
                    : ''}
                  ${hit.named_tags && hit.named_tags['apparel-group']
                    ? html`
                        <div class="product-card__apparel-badge">
                          More Sizes Available
                        </div>
                      `
                    : ''}
                </a>



                <!-- Product Tags -->
                ${hit.tags &&
                hit.tags.length > 0 &&
                html`
                  <div class="product-card__tags">
                    ${hit.tags.map(
                      /** @param {any} tag */ (tag) => html`
                        ${tag.startsWith('Badge_')
                          ? html`
                              <span class="product-card__tag tag"
                                >${tag.replace('Badge_', '')}</span
                              >
                            `
                          : ''}
                      `
                    )}

                    ${hit.tags.includes('staff-review')
                      ? html`
                          <button
                            type="button"
                            class="product-card__tag tag product-card__staff-review"
                            data-staff-review="${hit.handle}"
                            aria-haspopup="dialog"
                            aria-label="Read the staff review of ${cleanTitle}"
                          >
                            Staff Review →
                          </button>
                        `
                      : ''}
                  </div>
                `}

                <!-- Product Title -->
                <a
                  class="product-card__title p is-small is-bold"
                  href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                >
                  ${cleanTitle}
                </a>


                <!-- Author or Publisher Name -->
                ${hit.meta?.custom?.author_illustrator_artist_etc &&
                html`
                  <div class="product-card__author-publisher">
                    ${parseAuthors(hit.meta.custom.author_illustrator_artist_etc).map(
                      /**
                       * @param {string} author_value
                       * @param {number} index
                       */
                      (author_value, index) => html`
                        <a
                          href="/search?q=${encodeURIComponent(author_value)}"
                          class="p is-small"
                        >
                          ${author_value}
                        </a>
                        ${index !== parseAuthors(hit.meta.custom.author_illustrator_artist_etc).length - 1 ? ', ' : ''}
                      `
                    )}
                  </div>
                `}

                ${!hit.meta?.custom?.author_illustrator_artist_etc &&
                hit.meta?.custom?.publisher &&
                html`
                  <a
                    href="/search?q=${hit.meta.custom.publisher}"
                    class="product-card__author-publisher p is-small"
                  >
                    ${hit.meta.custom.publisher}
                  </a>
                `}

                <!-- Yotpo Review Stars -->
                <div
                  class="yotpo-widget-instance"
                  data-yotpo-instance-id="1191105"
                  data-yotpo-product-id="${hit.id}"
                  data-yotpo-section-id="index"
                ></div>

                <!-- Format -->
                ${hit.meta?.custom?.format &&
                html`
                  <span class="product-card__format p is-small">
                    ${hit.meta.custom.format}
                  </span>
                `}

                <div class="product-pricing product-card__pricing p is-large">
                ${showStrikethrough
                  ? html`
                      <p class="product-pricing__compare">
                        ${algoliaShopify.helpers.displayPrice({ price: displayOriginalPrice })}
                      </p>
                      <p class="product-pricing__price" data-price="${displaySalePrice}">
                        ${algoliaShopify.helpers.displayPrice({ price: displaySalePrice })}
                      </p>
                    `
                  : html`
                      <p class="product-pricing__price" data-price="${hit.price}">
                        ${algoliaShopify.helpers.displayPrice(hit)}
                      </p>
                    `}
              </div>





                <!-- Product Discount -->
                ${discountPercentage > 0 &&
                html`
                  <span
                    class="product-discount product-card__discount p is-small"
                  >
                    ${Theme.translations.discount?.replace(
                      '{{ percentage }}',
                      `${discountPercentage}%`
                    )}
                  </span>
                `}

                <!-- Add to Cart Form -->
                ${!isApparelGroup
                  ? html`
                      <algolia-product-form-component
                        data-product-id="${hit.id}"
                        class="product-form__form"
                      >
                        <div
                          class="visually-hidden"
                          aria-live="assertive"
                          role="status"
                          aria-atomic="true"
                        ></div>

                        <form
                          id="product-form-${hit.objectID}"
                          action="/cart/add"
                          method="post"
                          enctype="multipart/form-data"
                          data-type="add-to-cart-form"
                        >
                          <input type="hidden" name="id" value="${hit.objectID}" />
                          <input type="hidden" name="quantity" value="1" />

                          <button
                            data-add-to-cart-button-algolia
                            id="addToCartButton-${hit.objectID}"
                            type="submit"
                            name="add"
                            class="add-to-cart-btn product-form__add-button button for-card 
                            ${hit.inventory_available ? '' : 'disabled'}"
                          >
                            <span class="add-to-cart-text">
                              <span class="add-to-cart-text__content">
                                ${isPreorder
                                  ? Theme.translations.preorder
                                  : isBackorder
                                  ? Theme.translations.backorder
                                  : hit.inventory_available
                                  ? Theme.translations.add_short
                                  : Theme.translations.out_of_stock}
                              </span>
                            </span>
                            <span
                              aria-hidden="true"
                              class="add-to-cart-text--added"
                            >
                              <span>${Theme.translations.added}</span>
                            </span>
                          </button>
                        </form>
                      </algolia-product-form-component>
                    `
                  : html`
                    <a
                      href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                      class="add-to-cart-btn product-form__add-button button for-card no-icon"
                    >
                      View Sizes
                    </a>
                  `

                }

                <!-- SWYM Wishlist Add Button -->
                ${html`
                  <button
                    class="swym-add-to-wishlist-view-product product_${hit.id} wishlist-add-button product-card__wishlist"
                    data-with-epi="true"
                    data-swaction="addToWishlist"
                    data-product-id="${hit.id}"
                    data-variant-id="${hit.objectID}"
                    data-product-url="${window.shopUrl}${algoliaShopify.helpers.instantsearchLink(
                      hit
                    )}"
                  >
                    <svg
                      viewBox="0 0 21 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.3626 2.41452C17.9144 1.96607 17.3822 1.61034 16.7965 1.36763C16.2107 1.12492 15.5829 1 14.9488 1C14.3148 1 13.6869 1.12492 13.1012 1.36763C12.5154 1.61034 11.9832 1.96607 11.535 2.41452L10.6048 3.34476L9.67453 2.41452C8.76913 1.50912 7.54115 1.00047 6.26072 1.00047C4.98029 1.00047 3.75231 1.50912 2.84691 2.41452C1.94151 3.31992 1.43286 4.5479 1.43286 5.82833C1.43286 7.10875 1.94151 8.33674 2.84691 9.24214L10.6048 17L18.3626 9.24214C18.8111 8.79391 19.1668 8.26171 19.4095 7.67596C19.6522 7.0902 19.7772 6.46237 19.7772 5.82833C19.7772 5.19428 19.6522 4.56645 19.4095 3.9807C19.1668 3.39494 18.8111 2.86275 18.3626 2.41452Z"
                        stroke="#282828"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                `}
              </div>
            </div>
          `;
        }
      );

      // Autocomplete - options settings
      // Alex code hidden
      // algoliaShopify.hooks.registerHook(
      //   'beforeAutocompleteOptions',
      //   function (/** @type {any} */ options) {
      //     options.panelContainer = '#acpanel';
      //     options.detachedMediaQuery = '(max-width: none)';
      //     options.placeholder = Theme.translations.search_placeholder;
      //     return options;
      //   },
      // );
      // Alex code start
      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteOptions',
        function (/** @type {any} */ options) {
          options.panelContainer = '#acpanel';
          options.detachedMediaQuery = '(max-width: none)';
          options.placeholder = Theme.translations.search_placeholder;
          options.openOnFocus = true;

          // Swap the search drawer between its static default content
          // (search-drawer.liquid) and Algolia's results.
          // data-search-state: 'default' | 'results' | 'empty'
          const MIN_QUERY_LENGTH = 3;
          const previousOnStateChange = options.onStateChange;

          options.onStateChange = (/** @type {any} */ params) => {
            if (typeof previousOnStateChange === 'function') {
              previousOnStateChange(params);
            }

            const drawer = document.querySelector('[data-search-drawer]');
            if (!drawer) return;

            const { state, prevState } = params;
            const query = String(state.query || '').trim();

            // Under the minimum: always show the default content
            if (query.length < MIN_QUERY_LENGTH) {
              drawer.setAttribute('data-search-state', 'default');
              return;
            }

            // New results have arrived. Keyed on the results changing (not on
            // the query or loading status), so the default content stays up
            // while the first results load - no blank flash on the 3rd keystroke.
            if (state.collections !== prevState?.collections) {
              const hasResults = (state.collections || []).some(
                (/** @type {any} */ collection) => collection.items?.length > 0
              );

              if (!hasResults) {
                const message = drawer.querySelector('[data-search-no-results]');
                if (message instanceof HTMLElement) {
                  message.textContent = (message.dataset.template || '').replace(
                    '[query]',
                    query
                  );
                }
              }

              drawer.setAttribute(
                'data-search-state',
                hasResults ? 'results' : 'empty'
              );
              return;
            }

            // Results panel closed without new results (click outside, Escape):
            // bring the default content back rather than leaving a blank drawer
            if (
              drawer.getAttribute('data-search-state') === 'results' &&
              prevState?.isOpen &&
              !state.isOpen
            ) {
              drawer.setAttribute('data-search-state', 'default');
            }
          };

          return options;
        },
      );

      // Focus the search input when the search drawer opens
      document.querySelectorAll('[data-search-drawer-open]').forEach((trigger) => {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          setTimeout(function () {
            const acInput = document.querySelector('.aa-Input');
            if (acInput instanceof HTMLInputElement) {
              acInput.focus();
            }
          }, 150); // allow drawer open animation to complete
        });
      });

      // Alex code end

      // Autocomplete - render custom main template
      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteMainTemplate',
        /**
         * @param {any} _defaultTemplate
         * @param {any} templateOptions
         * @param {any} elements
         * @param {any} displaySuggestions
         */
        function (
          _defaultTemplate,
          templateOptions,
          elements,
          displaySuggestions
        ) {
          console.log('elements', Object.keys(elements));
          console.log('beforeAutocompleteMainTemplate', templateOptions);
          const { html } = templateOptions;
          return html`
            <div class="aa-PanelLayout aa-Panel--scrollable">
              <div class="aa-PanelSections">
                ${displaySuggestions &&
                html`
                  <div class="aa-SourceHeader">
                    <span class="aa-SourceHeaderTitle"
                      >${algoliaShopify.translations.suggestions}</span
                    >
                  </div>
                  ${elements.querySuggestionsPlugin}
                `}
                ${elements.collections} ${elements.articles} ${elements.pages} ${elements.products}
              </div>
            </div>
          `;
        }
      );

      // Autocomplete - render custom headings template
      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteHeaderTemplate',
        /**
         * @param {any} _defaultTemplate
         * @param {any} templateOptions
         * @param {any} resource
         */
        function (_defaultTemplate, templateOptions, resource) {
          const { html, state } = templateOptions;
          if (resource === 'Pages') {
            return html`<span class="p is-bold">Help & Information</span>`;
          }
          return html`
            <span class="p is-bold">
              ${resource === 'Products'
                ? 'Products'
                : algoliaShopify.translation_helpers.render_title(
                    resource,
                    state.query
                  )}
            </span>
          `;
        }
      );

      // Autocomplete - render custom collections template
      // algoliaShopify.hooks.registerHook(
      //   'beforeAutocompleteCollectionsTemplate',
      //   /**
      //    * @param {any} _defaultTemplate
      //    * @param {any} templateOptions
      //    * @param {any} itemLink
      //    */
      //   function (_defaultTemplate, templateOptions, itemLink) {
      //     const { html, item, components } = templateOptions;
      //     return html`
      //       <a href="${itemLink}" class="aa-ItemLink p">
      //         ${components.Highlight({ hit: item, attribute: 'title' })}
      //       </a>
      //     `;
      //   }
      // );

      // Collection images in search drawer
      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteCollectionsTemplate',
        /**
         * @param {any} _defaultTemplate
         * @param {any} templateOptions
         * @param {any} itemLink
         */
        function (_defaultTemplate, templateOptions, itemLink) {
          const { html, item, components } = templateOptions;
          const image = item.image || item.featured_image || null;
          const collectionType = item.meta?.custom?.collection_type || 'Collection';

          return html`
            <a href="${itemLink}" class="aa-ItemLink p aa-ItemLink--collection">
              <div class="aa-ItemIcon aa-ItemIcon--picture" style="box-shadow:none;background:none;border-radius:50%;overflow:hidden;flex-shrink:0;">
                ${image
                  ? html`<img src="${image}" alt="${item.title}" width="60" height="60" loading="lazy" />`
                  : html`<img src="https://cdn.shopify.com/s/files/1/0925/8981/8143/files/square_logo.png?v=1789000317" alt="Koorong" width="60" height="60" loading="lazy" />`
                }
              </div>
              <div class="aa-ItemContent">
                <div class="aa-ItemContentTitle">
                  ${components.Highlight({ hit: item, attribute: 'title' })}
                </div>
                <div class="aa-ItemContentSubtitle">${collectionType}</div>
              </div>
            </a>
          `;
        }
      );

      // Pages in search drawer
      algoliaShopify.hooks.registerHook(
        'beforeAutocompletePagesTemplate',
        /**
         * @param {any} _defaultTemplate
         * @param {any} templateOptions
         * @param {any} itemLink
         */
        function (_defaultTemplate, templateOptions, itemLink) {
          const { html, item, components } = templateOptions;

          const summary = item.body
            ? String(item.body).replace(/\s+/g, ' ').trim().slice(0, 90)
            : '';

          return html`
            <a href="${itemLink}" class="aa-ItemLink p aa-ItemLink--page">
              <div class="aa-ItemContent">
                <div class="aa-ItemContentTitle">
                  ${components.Highlight({ hit: item, attribute: 'title' })}
                </div>
                ${summary
                  ? html`<div class="aa-ItemContentSubtitle">${summary}…</div>`
                  : html`<div class="aa-ItemContentSubtitle"></div>`}
              </div>
            </a>
          `;
        }
      );  


      // Autocomplete - render custom product template
      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteProductTemplate',
        /**
         * @param {any} _defaultTemplate
         * @param {any} templateOptions
         * @param {any} distinct
         * @param {any} itemLink
         * @param {any} trackSearchAttribution
         */
        function (
          _defaultTemplate,
          templateOptions,
          distinct,
          itemLink,
          trackSearchAttribution
        ) {
          const { html, item, components } = templateOptions;
          const PLACEHOLDER_URL = 'https://koorong.com/cdn/shop/files/Shopify_Placeholder_Image.png';
          const autocompleteImage = algoliaShopify.helpers.renderImage(item, 133);
          const finalImageSrc = autocompleteImage.src && !autocompleteImage.src.includes('no-image-compact.gif')
            ? autocompleteImage.src
            : PLACEHOLDER_URL;

          return html`
            <a
              href="${itemLink}"
              class="aa-ItemLink aa-ProductItem"
              onClick="${() => trackSearchAttribution(item)}"
            >
              <div class="aa-ItemContent">
                <div class="aa-ItemPicture aa-ItemPicture--loaded">
                  <img
                    src="${finalImageSrc}"
                    srcset="${autocompleteImage.srcset}"
                    sizes="${autocompleteImage.sizes}"
                    alt="${item.title}"
                  />

                </div>
                <div class="aa-ItemContentBody">
                  <div class="p is-xsmall">
                    ${components.Highlight({ hit: item, attribute: 'title' })}
                  </div>

                  ${item.meta?.custom?.author_illustrator_artist_etc &&
                  html`
                    <span class="p is-xsmall">
                      ${String(item.meta.custom.author_illustrator_artist_etc)
                        .replace(/,/g, ', ')
                        .replace(/\s+/g, ' ')
                        .trim()
                        .slice(0, 80)}
                    </span>
                  `}
                </div>
              </div>
            </a>
          `;
        }
      );
    });

    // On InstantSearch widgets rendered
    document.addEventListener('algolia.instantSearch.onRender', function () {
      const instantSearch = document.querySelector(
        '#algolia-shopify-instantsearch'
      );
      if (!instantSearch) return;
      instantSearch.classList.add('is-rendered');

      // Custom category hierarchy implementation
      const categoryLevel0 = instantSearch.querySelector(
        '.ais-facet-category\\.lvl0-container'
      );
      const categoryLevel0Items =
        categoryLevel0?.querySelectorAll('.ais-facet--item');
      const categoryLevel1 = instantSearch.querySelector(
        '.ais-facet-category\\.lvl1-container'
      );
      const categoryLevel1Items =
        categoryLevel1?.querySelectorAll('.ais-facet--item');
      const categoryLevel2 = instantSearch.querySelector(
        '.ais-facet-category\\.lvl2-container'
      );
      const categoryLevel2Items =
        categoryLevel2?.querySelectorAll('.ais-facet--item');
      const checkIfCategoryLevel0ItemsAreSelected = () => {
        if (!categoryLevel0Items) return false;
        return Array.from(categoryLevel0Items).some((item) =>
          item.classList.contains('ais-Menu-item--selected')
        );
      };
      // Remove any previously injected items first
      const existingInjected = categoryLevel0?.querySelectorAll(
        '.hierarchy-injected'
      );
      existingInjected?.forEach((item) => item.remove());
      categoryLevel0?.classList.remove('is-filter-active');
      if (checkIfCategoryLevel0ItemsAreSelected()) {
        categoryLevel0?.classList.add('is-filter-active');

        // Check if any level 1 items are selected
        const checkIfCategoryLevel1ItemsAreSelected = () => {
          if (!categoryLevel1Items) return false;
          return Array.from(categoryLevel1Items).some((item) =>
            item.classList.contains('ais-RefinementList-item--selected')
          );
        };

        const isLevel1Selected = checkIfCategoryLevel1ItemsAreSelected();

        // Clone and inject level 1 items
        categoryLevel1Items?.forEach((lvl1Item) => {
          const isSelected = lvl1Item.classList.contains(
            'ais-RefinementList-item--selected'
          );

          // If any level 1 is selected and this one isn't, skip it (hide it)
          if (isLevel1Selected && !isSelected) {
            return;
          }

          const clonedItem = lvl1Item.cloneNode(true);
          if (clonedItem instanceof HTMLElement) {
            clonedItem.classList.add('hierarchy-injected', 'hierarchy-lvl1');

            const countEl = clonedItem
              .querySelector('.ais-facet--count-distinct')
              ?.cloneNode(true);
            clonedItem.querySelector('.ais-facet--count-distinct')?.remove();
            const fullText = clonedItem.textContent || '';
            const parts = fullText.split(' > ');
            clonedItem.innerHTML = `<div><label class="ais-RefinementList-label ais-facet--label">${
              parts[parts.length - 1] || ''
            }<span class="ais-facet--count-distinct">${
              countEl?.textContent || ''
            }</span></label></div>`;

            // Set up click handler to trigger the original item
            const clonedLabel = clonedItem.querySelector(
              '.ais-RefinementList-label'
            );
            const originalLabel = lvl1Item.querySelector(
              '.ais-RefinementList-label'
            );
            if (clonedLabel && originalLabel instanceof HTMLElement) {
              clonedLabel.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                originalLabel.click();
              });
            }

            categoryLevel0?.appendChild(clonedItem);
          }
        });

        // Clone and inject level 2 items if level 1 is selected
        if (isLevel1Selected) {
          categoryLevel2Items?.forEach((lvl2Item) => {
            const clonedItem = lvl2Item.cloneNode(true);
            if (clonedItem instanceof HTMLElement) {
              clonedItem.classList.add('hierarchy-injected', 'hierarchy-lvl2');

              // Simplify the text to show only the last part after ' > '
              const countEl = clonedItem
                .querySelector('.ais-facet--count-distinct')
                ?.cloneNode(true);
              clonedItem.querySelector('.ais-facet--count-distinct')?.remove();
              const fullText = clonedItem.textContent || '';
              const parts = fullText.split(' > ');
              clonedItem.innerHTML = `<div><label class="ais-RefinementList-label ais-facet--label">${
                parts[parts.length - 1] || ''
              }<span class="ais-facet--count-distinct">${
                countEl?.textContent || ''
              }</span></label></div>`;

              // Set up click handler to trigger the original item
              const clonedLabel = clonedItem.querySelector(
                '.ais-RefinementList-label'
              );
              const originalLabel = lvl2Item.querySelector(
                '.ais-RefinementList-label'
              );

              if (clonedLabel && originalLabel instanceof HTMLElement) {
                clonedLabel.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  originalLabel.click();
                });
              }

              categoryLevel0?.appendChild(clonedItem);
            }
          });
        }
      } else {
        // If level 0 is not selected, deactivate any selected level 1 and level 2 items
        categoryLevel1Items?.forEach((lvl1Item) => {
          if (
            lvl1Item.classList.contains('ais-RefinementList-item--selected')
          ) {
            const label = lvl1Item.querySelector('.ais-RefinementList-label');
            if (label instanceof HTMLElement) {
              label.click();
            }
          }
        });

        categoryLevel2Items?.forEach((lvl2Item) => {
          if (
            lvl2Item.classList.contains('ais-RefinementList-item--selected')
          ) {
            const label = lvl2Item.querySelector('.ais-RefinementList-label');
            if (label instanceof HTMLElement) {
              label.click();
            }
          }
        });
      }

      // Facets - clean up array facet labels
      const facetLabels = instantSearch.querySelectorAll('.ais-RefinementList-label');
      facetLabels.forEach((label) => {
        const nodes = Array.from(label.childNodes);
        nodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            if (text && text.startsWith('[')) {
              node.textContent = JSON.parse(text).join(', ');
            }
          }
        });
      });

      // Sort
      const sortSelect = instantSearch.querySelector('.ais-SortBy-select');
      sortSelect?.classList.add('select');
      const sortOptions = instantSearch.querySelectorAll('.ais-SortBy-option');
      sortOptions.forEach((option) => {
        if (option.classList.contains('is-rendered')) return;
        option.classList.add('is-rendered');
        const optionText = option.textContent;
        if (optionText && Theme.translations.sort_button) {
          option.textContent = Theme.translations.sort_button.replace(
            '{{ option }}',
            optionText
          );
        }
      });

      // Filters show button
      const filtersShowButton = instantSearch.querySelector(
        '[data-filters-show]'
      );
      filtersShowButton?.addEventListener('click', (e) => {
        e.preventDefault();
        instantSearch
          .querySelector('.ais-facets')
          ?.classList.add('ais-facets__shown');
        document.body.setAttribute('data-lock-scroll', 'true');
      });

      // Filters close button
      const filtersCloseButtons = instantSearch.querySelectorAll(
        '[data-filters-close]'
      );
      filtersCloseButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          instantSearch
            .querySelector('.ais-facets')
            ?.classList.remove('ais-facets__shown');

          // Close all open dropdowns
          const dropdowns = instantSearch.querySelectorAll(
            '.ais-dropdown-checkbox'
          );
          dropdowns.forEach((dropdown) => {
            /** @type {HTMLInputElement} */ (dropdown).checked = false;
          });

          document.body.removeAttribute('data-lock-scroll');
        });
      });
      const filtersBackButtons = instantSearch.querySelectorAll(
        '[data-filters-back]'
      );

      // Filters back button
      filtersBackButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const parent = button.closest('.ais-facet-dropdown-wrapper');
          const checkbox = parent?.querySelector('.ais-dropdown-checkbox');
          if (!checkbox) return;
          /** @type {HTMLInputElement} */ (checkbox).checked = false;

          setTimeout(updateFiltersSelected, 500);
        });
      });

      // Filters clear button
      const filtersClearButtons = instantSearch.querySelectorAll(
        '[data-filters-clear]'
      );
      filtersClearButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const parent = button.closest('.ais-facet-dropdown-wrapper');
          const options = parent?.querySelectorAll(
            '.ais-RefinementList-item, .ais-Menu-item'
          );
          options?.forEach((/** @type {HTMLElement} */ option) => {
            if (
              !option.classList.contains('ais-RefinementList-item--selected') &&
              !option.classList.contains('ais-Menu-item--selected')
            )
              return;
            option.click();
          });
          const selectAllButton = parent?.querySelector(
            '.collection__select-all'
          );
          if (selectAllButton) selectAllButton.classList.remove('is-selected');
        });
      });

      // Filters insert select all button
      const searchBoxes = instantSearch.querySelectorAll(
        '.ais-RefinementList-searchBox'
      );
      searchBoxes.forEach((searchBox) => {
        const parent = searchBox.closest('.ais-facet-dropdown-container');
        if (parent?.classList.contains('is-select-all-rendered')) return;

        parent?.classList.add('is-select-all-rendered');
        const selectAllButton = document.createElement('button');
        selectAllButton.classList.add(
          'collection__select-all',
          'ais-facet--label',
          'button-unstyled'
        );
        selectAllButton.textContent = 'Select all';
        searchBox.appendChild(selectAllButton);

        // Select all button logic
        selectAllButton.addEventListener('click', (e) => {
          e.preventDefault();
          selectAllButton.classList.toggle('is-selected');
          const isSelected = selectAllButton.classList.contains('is-selected');
          const options = parent?.querySelectorAll('.ais-RefinementList-item');
          options?.forEach((/** @type {HTMLElement} */ option) => {
            if (
              (isSelected &&
                !option.classList.contains(
                  'ais-RefinementList-item--selected'
                )) ||
              (!isSelected &&
                option.classList.contains('ais-RefinementList-item--selected'))
            ) {
              option.click();
              return;
            }
          });
        });
      });

      // Extra select all button logic
      const clearAllButton = instantSearch.querySelector(
        '.ais-ClearRefinements-button'
      );
      clearAllButton?.addEventListener('click', () => {
        // don't prevent default
        const selectAllButtons = instantSearch.querySelectorAll(
          '.collection__select-all'
        );
        selectAllButtons.forEach((button) => {
          button.classList.remove('is-selected');
        });
      });

      // Filters search input
      const filtersSearchInputs = instantSearch.querySelectorAll(
        '.ais-SearchBox-input'
      );
      filtersSearchInputs.forEach((input) => {
        /** @type {HTMLInputElement} */ (input).placeholder = 'Search ...';
      });

      // Filters show selected
      const updateFiltersSelected = () => {
        const filtersSelected = instantSearch.querySelectorAll(
          '[data-filters-selected]'
        );
        const filtersSelectedAll = instantSearch.querySelector(
          '[data-filters-selected-all]'
        );
        if (filtersSelectedAll) {
          filtersSelectedAll.innerHTML = `
            <button class="collection__filters-selected-button button-unstyled" 
              data-filters-clear-all-button
            >
              Clear all
            </button>
          `;
        }
        filtersSelected.forEach((selectedElement) => {
          const facetName = selectedElement.getAttribute('data-facet-name');
          if (!facetName) return;

          const urlParams = new URLSearchParams(window.location.search);
          /** @type {string[]} */
          const selectedValues = [];

          urlParams.forEach((value, key) => {
            // Check for refinementList parameters
            const refinementPattern = `refinementList[${facetName}]`;
            if (key.startsWith(refinementPattern)) {
              selectedValues.push(value);
            }

            // Check for range parameters
            const rangePattern = `range[${facetName}]`;
            if (key === rangePattern) {
              // Format range like "5:40" to "5 to 40"
              const rangeParts = value.split(':');
              if (rangeParts.length === 2) {
                if (rangeParts[0] === '') rangeParts[0] = '0';
                if (rangeParts[1] === '') rangeParts[1] = 'max';
                selectedValues.push(`$${rangeParts[0]} - ${rangeParts[1]}`);
              }
            }

            // Check for menu parameters
            const menuPattern = `menu[${facetName}]`;
            if (key === menuPattern) {
              selectedValues.push(value);
            }
          });

          selectedElement.textContent = selectedValues.join(', ');
          if (filtersSelectedAll)
            selectedValues.forEach((value) => {
              let displayValue = value;
              if (displayValue && displayValue.startsWith('[')) {
                displayValue = JSON.parse(displayValue).join(', ');
              }

              filtersSelectedAll.innerHTML += `
                <button 
                  class="collection__filters-selected-button button-unstyled"
                  data-facet-name="${facetName}"
                  data-filters-selected-button="${encodeURIComponent(value)}"
                >
                  ${displayValue}
                </button>
              `;
            });
        });

        // Filters selected button remove filter logic (desktop)
        const filtersSelectedButtons = instantSearch.querySelectorAll(
          '[data-filters-selected-button]'
        );
        filtersSelectedButtons.forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            const facetName = button.getAttribute('data-facet-name');
            const filterValue = decodeURIComponent(
              button.getAttribute('data-filters-selected-button') || ''
            );
            if (!facetName || !filterValue) return;

            const currentUrl = new URL(window.location.href);
            const params = currentUrl.searchParams;

            if (facetName == 'price') {
              params.delete(`range[${facetName}]`);
            } else if (facetName == 'category.lvl0') {
              params.delete(`menu[${facetName}]`);
            } else {
              /** @type {string[]} */ const keysToDelete = [];
              params.forEach((value, key) => {
                if (
                  key.startsWith(`refinementList[${facetName}]`) &&
                  value === filterValue
                ) {
                  keysToDelete.push(key);
                }
              });
              keysToDelete.forEach((key) => params.delete(key));
            }

            const newUrl = `${currentUrl.pathname}${
              params.toString() ? '?' + params.toString() : ''
            }`;
            window.history.replaceState({}, '', newUrl);
            window.dispatchEvent(new PopStateEvent('popstate'));
          });
        });

        // Filters clear all button logic
        const filtersClearAllButton = instantSearch.querySelector(
          '[data-filters-clear-all-button]'
        );
        filtersClearAllButton?.addEventListener('click', (e) => {
          e.preventDefault();
          const currentUrl = new URL(window.location.href);
          const params = currentUrl.searchParams;

          /** @type {string[]} */ const keysToDelete = [];
          params.forEach((value, key) => {
            if (
              key.startsWith('refinementList[') ||
              key.startsWith('range[') ||
              key.startsWith('menu[')
            ) {
              keysToDelete.push(key);
            }
          });

          keysToDelete.forEach((key) => params.delete(key));

          const newUrl = `${currentUrl.pathname}${
            params.toString() ? '?' + params.toString() : ''
          }`;
          window.history.replaceState({}, '', newUrl);
          window.dispatchEvent(new PopStateEvent('popstate'));
        });
      };
      setTimeout(updateFiltersSelected, 500);

      // Filters close all open dropdowns (for desktop)
      const dropdownCheckboxes = instantSearch.querySelectorAll(
        '.ais-dropdown-checkbox'
      );
      dropdownCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
          // don't prevent default
          dropdownCheckboxes.forEach((dropdown) => {
            if (dropdown === checkbox) return;
            /** @type {HTMLInputElement} */ (dropdown).checked = false;
          });
        });
      });
      document.body.addEventListener('click', (e) => {
        // don't prevent default
        if (
          (e.target instanceof Element &&
            e.target.closest('.collection__filters')) ||
          (e.target instanceof Element &&
            e.target.closest('.collection__filters-dropdown')) ||
          (e.target instanceof Element &&
            e.target.closest('.ais-facet-dropdown-container')) ||
          (e.target instanceof Element && e.target.closest('.ais-facet--item'))
        )
          return;
        dropdownCheckboxes.forEach((dropdown) => {
          /** @type {HTMLInputElement} */ (dropdown).checked = false;
        });
      });      

      // Description read more button
      const collection = document.querySelector('[data-collection]');
      const descriptionReadMoreButton = instantSearch.querySelector(
        '[data-description-read-more]'
      );
      descriptionReadMoreButton?.addEventListener('click', (e) => {
        e.preventDefault();
        collection?.setAttribute('data-show-description', 'true');
      });

        // Sticky filters
        const filtersContainer = instantSearch.querySelector(
          '.collection__filters-main'
        );
        if (filtersContainer && !filtersContainer.dataset.stickyBound) {
          filtersContainer.dataset.stickyBound = 'true';

          // Zero-height marker sitting in normal flow, just above the bar.
          // When it scrolls out of the top of the viewport, the bar sticks.
          const sentinel = document.createElement('div');
          sentinel.className = 'collection__filters-sentinel';
          sentinel.setAttribute('aria-hidden', 'true');
          filtersContainer.parentNode?.insertBefore(sentinel, filtersContainer);

          const observer = new IntersectionObserver(
            ([entry]) => {
              filtersContainer.classList.toggle(
                'is-sticky',
                !entry.isIntersecting && entry.boundingClientRect.top <= 0
              );
            },
            { threshold: 0 }
          );

          observer.observe(sentinel);
        }

      // Collection blocks
      const collectionBlocks = document.querySelectorAll(
        '[data-collection-block]'
      );
      collectionBlocks.forEach((block) => {
        const position = parseInt(block.getAttribute('data-position') || '1');
        const products = document.querySelectorAll('.ais-Hits-item');
        let product = products[position - 1];
        if (!product) {
          product = products[products.length - 1];
          product?.insertAdjacentElement('afterend', block);
          return;
        }
        product?.parentNode?.insertBefore(block, product);
      });

      // Yotpo review stars
      if (typeof window.yotpoWidgetsContainer?.initWidgets === 'function') {
        window.yotpoWidgetsContainer.initWidgets();
      }

      // SWYM Wishlist add buttons
      window._swat?.initializeActionButtons('[data-collection]');
    });
  }
}

/**
 * Safely parses the author field, handling both JSON strings and plain strings
 * @param {string} value
 * @returns {string[]}
 */
const parseAuthors = (value) => {
  if (Array.isArray(value)) return value;

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [String(parsed)];
  } catch {
    return [value];
  }
};

new AlgoliaComponent();
